module.exports = __webpack_public_path__ + "img/architect-and-architectural.06333e51.jpg";